import { TweenMax, Back } from 'gsap';

const Animations = {
  searchInput: {
    in: (ref: React.MutableRefObject<any>, width: number) => {
      TweenMax.to(ref.current, 0.35, {
        width,
        ease: Back.easeOut,
      });
    },
    out: (ref: React.MutableRefObject<any>, width: number) => {
      TweenMax.to(ref.current, 0.5, {
        width,
        ease: Back.easeInOut,
      });
    },
  },
  modal: {
    in: (card: any) => {
      // TweenMax.killAll();
      TweenMax.set(card.current, { y: 0 });
      TweenMax.from(card.current, 0.5, {
        y: '+=100',
        ease: Back.easeOut,
      });
      TweenMax.to(card.current, 0.5, { opacity: 1, delay: 0 });
    },
    out: (card: any, callback?: () => void) => {
      TweenMax.to(card.current, 0.5, {
        y: '-=100',
        ease: Back.easeIn,
      });
      TweenMax.to(card.current, 0.15, { opacity: 0, delay: 0.35 });
      if (callback) TweenMax.delayedCall(0.5, callback);
    },
  },
  toolTip: {
    in: (
      ref: React.MutableRefObject<any>,
      position: string,
      width: number,
      height: number,
      center: number,
      delay: number
    ) => {
      let x: number | string;
      let y: number | string;
      const spacer: number = 10;

      switch (position) {
        case 'left':
          x = `-${width + spacer}`;
          y = 0;
          TweenMax.set(ref.current, { x: -width });
          break;
        case 'right':
          x = `${width + spacer}`;
          y = 0;
          TweenMax.set(ref.current, { x: width });
          break;
        case 'top':
          x = center;
          y = `-${height + spacer}`;
          TweenMax.set(ref.current, { x: center, y: -height });
          break;
        case 'bottom':
        default:
          x = center;
          y = `${height + spacer}`;
          TweenMax.set(ref.current, { x: center, y: height });
          break;
      }
      TweenMax.to(ref.current, 0.35, {
        autoAlpha: 1,
        x,
        y,
        ease: Back.easeOut,
        delay,
      });
    },
    out: (
      ref: React.MutableRefObject<any>,
      position: string,
      width: number,
      height: number,
      center: number
    ) => {
      let x: number | string;
      let y: number | string;
      const spacer: number = 10;

      switch (position) {
        case 'left':
          x = `+=${spacer}`;
          y = 0;
          break;
        case 'right':
          x = `-=${spacer}`;
          y = 0;
          break;
        case 'top':
          x = center;
          y = `+=${spacer}`;
          break;
        case 'bottom':
        default:
          x = center;
          y = `-=${spacer}`;
          break;
      }
      TweenMax.killTweensOf(ref.current);
      TweenMax.to(ref.current, 0.35, {
        x,
        y,
        autoAlpha: 0,
        ease: Back.easeIn,
      });
    },
  },
};

export default Animations;
